import { useInstanceStore } from 'src/stores/instance.js'

import { nameInitial } from 'src/services/rich_text/rich_text.js'
import generateProfileLink from 'src/services/user_profile_link_generator/user_profile_link_generator'

// How the interface names and links a user, one rule each.

// the display name as typed, else the handle, else the id of a user that
// is not loaded yet
export const displayName = (user) =>
  user.name_unescaped ||
  user.name ||
  user.screen_name_ui ||
  user.screen_name ||
  user.id

// one letter for a user with no picture
export const userInitial = (user) =>
  nameInitial(user.name_unescaped || user.name, user.screen_name)

// the route of the profile page
export const profileLink = (user) =>
  generateProfileLink(
    user.id,
    user.screen_name,
    useInstanceStore().restrictedNicknames,
  )
